import {FinancialCalculatorPlugin} from "./financialCalculatorPlugin";
import * as Sentry from "@sentry/browser";

let json = null,
    template = null,
    templateOffer = null,
    calculator = {
        visual: {},
        model: {}
    },
    listBlockCalculator = [],
    fcp = new FinancialCalculatorPlugin(app_js.config_calculator_api);
const clientTypeLeasing = 'l101';
let withCalculationParams = false;

const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());
if (params['calculator-test'] !== undefined) {
    withCalculationParams = true;
    fcp.setWithCalculationParams(true);
}

fcp.onUpdateOfferDetection = (a, b) => {
    createCalculator(a, b);
};

fcp.onUpdateOfferCalculation = (a, b, clientType) => {
    createCalculator(a, b);
};

fcp.onErrorOfferDetection = (a, b) => {
    errorOffer(a, b);
};

fcp.onErrorOfferCalculation = (a, b) => {
    errorOffer(a, b);
};

function errorOffer(a, b) {
    let position = b.getId().split('-')[0];
    let calculatorPath = '.calculator-' + position + '-' + b.getData().modelCode + '[data-version-id="' + b.getId() + '"]';

    if ($(calculatorPath).length) {
        let $calc = $(calculatorPath);
        listBlockCalculator[b.getId()] = false;

        if (position === 'visual') {
            $calc.find('.carousel__headline-installment').addClass('blur');
            $calc.find('.calculator-sliders').css('visibility', 'visible');
            $calc.find('.visual-calculator-error').addClass('inline-block');
            $calc.find('.visual-calculator-loader').removeClass('inline-block');
        } else {
            $calc.find('.model__headline-installment').addClass('blur');
            $calc.find('.calculator-sliders').css('visibility', 'visible');
            $calc.find('.model-calculator-error').addClass('inline-block');
            $calc.find('.model-calculator-loader').removeClass('inline-block');
            $calc.find('.model-surcharge-info').css('visibility', 'hidden');
        }
    }

    if (app_js.mode !== 'development') {
        Sentry.setContext('Details', {
            data: JSON.stringify(b),
        });

        Sentry.captureMessage('Błąd kalkulacji, Id:  ' + JSON.stringify(b.getId()));
    } else {
        console.log('Błąd kalkulacji dla danych: ' + JSON.stringify(b));
    }
}

function createCalculator(a, b) {
    let position = b.getId().split('-')[0];
    let modelCode = b.getData().modelCode;
    if (b.getData().modelName === 'Doblò Combi') {
        modelCode += '-doblo-combi';
    }

    let calculatorPath = '.calculator-' + position + '-' + modelCode + '[data-version-id="' + b.getId() + '"]';

    if ($(calculatorPath).length) {
        let $calc = $(calculatorPath);

        if (b.getCalculationByType(clientTypeLeasing) === null) {
            if (position === 'visual') {
                $calc.find('.carousel__headline-installment').addClass('blur');
                $calc.find('.calculator-sliders').css('visibility', 'visible');
                $calc.find('.visual-calculator-error').addClass('inline-block');
                $calc.find('.visual-calculator-loader').removeClass('inline-block');

                if (app_js.mode !== 'development') {
                    if (typeof Sentry !== 'undefined') {
                        Sentry.captureMessage('Brak produktu finansowego: ' + clientTypeLeasing + ', model: ' + b.getData().modelName + ' (' + b.getData().modelCode + '), sincom: ' + b.getData().versionId);
                    }
                }  else if (app_js.mode === 'development') {
                    console.log('Brak produktu finansowego: ' + clientTypeLeasing + ', model: ' + b.getData().modelName + ' (' + b.getData().modelCode + '), sincom: ' + b.getData().versionId);
                }
            } else {
                $calc.find('.model__headline-installment').addClass('blur');
                $calc.find('.calculator-sliders').css('visibility', 'visible');
                $calc.find('.model-calculator-error').addClass('inline-block');
                $calc.find('.model-calculator-loader').removeClass('inline-block');
                $calc.find('.model-surcharge-info').css('visibility', 'hidden');
            }

            return;
        }

        listBlockCalculator[b.getId()] = false;
        if (position === 'visual') {
            setInstallmentVisual(calculatorPath, b.getCalculationByType(clientTypeLeasing).installment, modelCode);
            $calc.find('.carousel__headline-installment').removeClass('blur');
            $calc.find('.calculator-sliders').css('visibility', 'visible');
            $calc.find('.visual-calculator-error').removeClass('inline-block');
            $calc.find('.visual-calculator-loader').removeClass('inline-block');
        } else {
            setInstallmentModel(calculatorPath, b.getCalculationByType(clientTypeLeasing).installment);
            $calc.find('.model__headline-installment').removeClass('blur');
            $calc.find('.calculator-sliders').css('visibility', 'visible');
            $calc.find('.model-calculator-error').removeClass('inline-block');
            $calc.find('.model-calculator-loader').removeClass('inline-block');
            $calc.find('.model-surcharge-info').css('visibility', 'visible');
            if (withCalculationParams) {
                setCalculationParams(b.getData().versionId, b.getCalculationByType(clientTypeLeasing), b.getData().versionId);
            }
        }

        $('#leasing-note').html(b.getCalculationByType(clientTypeLeasing).note);

        let first = true;
        if (b.getCalculationByType(clientTypeLeasing).orderFields !== undefined && b.getCalculationByType(clientTypeLeasing).orderFields.length > 0) {
            for (let key of b.getCalculationByType(clientTypeLeasing).orderFields) {
                if (b.getCalculationByType(clientTypeLeasing).currentFields[key] !== undefined &&
                    b.getCalculationByType(clientTypeLeasing).availableFields[key] !== undefined) {
                    createSlider(position, modelCode, b.getId(), key, b.getCalculationByType(clientTypeLeasing).currentFields[key],
                        b.getCalculationByType(clientTypeLeasing).availableFields[key], b.getCalculationByType(clientTypeLeasing).title, first);
                    first = false;
                }
            }
        } else {
            Object.keys(b.getCalculationByType(clientTypeLeasing).currentFields).forEach((key) => {
                createSlider(position, modelCode, b.getId(), key, b.getCalculationByType(clientTypeLeasing).currentFields[key],
                    b.getCalculationByType(clientTypeLeasing).availableFields[key], b.getCalculationByType(clientTypeLeasing).title, first);
                first = false;
            });
        }
    } else {
        if (app_js.mode === 'development') {
            console.log('Brak elementu: ' + calculatorPath);
        }
    }
}
$.get(app_js.base_url + 'assets/template/calculator.html?v=' + Date.now(), function(data){
    template = data;
    $.get(app_js.base_url + 'assets/template/calculator-offer.html?v=' + Date.now(), function(data){
        templateOffer = data;
        $.getJSON(app_js.base_url + 'api/get_financing.json?v=' + Date.now(), function(json_arr){
            json = json_arr;
            initSubscriptionCalculators();
            initLeasingCalculators();
            $('.loader-big').addClass('hide').removeClass('show');
        });
    });
});

$(document).on('click', '#calc', function(){
    reloadSubscriptionCalculators($(this));
});

// Ustawienia początkowe suwaków dla wynajmu
var initPrice = 1;
var initLimitKm = 0;
var initPackageVal = 0;
var initTimeVal = 0;

// Inicjalizacja kalkulatorów dla wynajmu
function initSubscriptionCalculators() {

    $("[data-calculator-init]").each(function() {
        var temp = template;
        if ($(this).data('calc-type') === 'offer') {
            temp = templateOffer;
        }

        var initialPrices = getInitialSubscriptionPrices($(this).data('calculator-init'), initPrice);
        var time = getTime($(this).data('calculator-init'), initPrice, initTimeVal);
        var limitKm = getSubscriptionLimitsKm($(this).data('calculator-init'), initPrice, initTimeVal, initLimitKm);
        var packageVal = getSubscriptionPackage($(this).data('calculator-init'), initPrice, initTimeVal, initLimitKm, initPackageVal);
        var price = getSubscriptionPrice($(this).data('calculator-init'), initPrice, initTimeVal, initLimitKm, initPackageVal);

        temp = temp.replace(/{{modelName}}/g, $(this).attr('data-model-name'));
        temp = temp.replace(/{{initialPrices}}/g, initialPrices);
        temp = temp.replace(/{{time}}/g, time);
        temp = temp.replace(/{{limitKm}}/g, limitKm);
        temp = temp.replace(/{{packageVal}}/g, packageVal);
        temp = temp.replace(/{{price}}/g, price);

        var packageName = 'WYBIERZ PAKIET';
        // var packageClass = 'two-fields';
        temp = temp.replace(/{{packageName}}/g, packageName);
        // temp = temp.replace(/{{packageClass}}/g, packageClass);
        $(this).html(temp);
        $(this).find("[data-price]").prop('number', price);
        // $(this).find("[data-price]").prop('number', priceToInt(price));

    });
}

function getInitialSubscriptionPrices(vehicle, active) {
    var string = '';
    if (json['subscription'][vehicle] && json['subscription'][vehicle]['subscription']) {
        $.each(json['subscription'][vehicle]['subscription'], function(k, v){
            if(k == active) {
                string = string + "<div data-id='"+k+"' data-calc='"+vehicle+"' class='isActive' data-prop='price' id='calc' " +
                  "style='width:" + Math.round((100 / (Object.keys(json['subscription'][vehicle]['subscription']).length)) * 100) / 100 + "%'>" +
                  v.description
                  +"</div>\n";
            } else {
                string = string + "<div data-id='"+k+"' data-calc='"+vehicle+"' data-prop='price' id='calc' " +
                  "style='width:" + Math.round((100 / (Object.keys(json['subscription'][vehicle]['subscription']).length)) * 100) / 100 + "%'>" +
                  v.description
                  +"</div>\n";
            }
        });
    }
    return string;
}

function getTime(vehicle, initPrice, active) {
    var string = '';
    if (json['subscription'][vehicle] && json['subscription'][vehicle]['subscription'][initPrice]) {
        $.each(json['subscription'][vehicle]['subscription'][initPrice].time, function(k, v){
            if(k == active) {
                string = string + "<div data-id='"+k+"' data-calc='"+vehicle+"' class='isActive' data-prop='time' id='calc' " +
                  "style='width:" + Math.round((100 / (Object.keys(json['subscription'][vehicle]['subscription'][initPrice].time).length)) * 100) / 100 + "%'>" +
                  v.description
                  +"</div>\n";
            } else {
                string = string + "<div data-id='"+k+"' data-calc='"+vehicle+"' data-prop='time' id='calc' " +
                  "style='width:" + Math.round((100 / (Object.keys(json['subscription'][vehicle]['subscription'][initPrice].time).length)) * 100) / 100 + "%'>" +
                  v.description
                  +"</div>\n";
            }
        });
    }
    return string;
}

function getSubscriptionLimitsKm(vehicle, initPrice, selectedTime, active) {
    var string = '';
    if (json['subscription'][vehicle]['subscription'][initPrice] &&
      json['subscription'][vehicle]['subscription'][initPrice] &&
      json['subscription'][vehicle]['subscription'][initPrice].time[selectedTime]
    ) {
        $.each(json['subscription'][vehicle]['subscription'][initPrice].time[selectedTime].limitKM, function(k, v){
            if (k !== "description") {
                if(k == active) {
                    string = string + "<div data-id='" + k + "' data-calc='" + vehicle + "' class='isActive' data-prop='limitKm' id='calc' " +
                        "style='width:" + Math.round((100 / (Object.keys(json['subscription'][vehicle]['subscription'][initPrice].time[selectedTime].limitKM).length)) * 100) / 100 + "%;'>"
                        + v.description + "" +
                        "</div>\n";
                } else {
                    string = string + "<div data-id='" + k + "' data-calc='" + vehicle + "' data-prop='limitKm' id='calc' " +
                        "style='width:" + Math.round((100 / (Object.keys(json['subscription'][vehicle]['subscription'][initPrice].time[selectedTime].limitKM).length)) * 100) / 100 + "%;'>"
                        + v.description + "</div>\n";
                }
            }
        });
    }
    return string;
}


function getSubscriptionPackage(vehicle, initPrice, selectedTime, initLimitKm, active) {
    var string = '';
    if (json['subscription'][vehicle] && json['subscription'][vehicle]['subscription'] &&
      json['subscription'][vehicle]['subscription'][initPrice] &&
      json['subscription'][vehicle]['subscription'][initPrice].time[selectedTime] &&
      json['subscription'][vehicle]['subscription'][initPrice].time[selectedTime].limitKM[initLimitKm]
    ) {
        $.each(json['subscription'][vehicle]['subscription'][initPrice].time[selectedTime].limitKM[initLimitKm].package, function(k, v){
            if(k == active) {
                string = string + "<div data-id='"+k+"' data-calc='"+vehicle+"' class='isActive' data-prop='packageVal' id='calc' " +
                    "style='width:" + Math.round((100 / (Object.keys(json['subscription'][vehicle]['subscription'][initPrice].time[selectedTime].limitKM[initLimitKm].package).length)) * 100) / 100 + "%'>" +
                    v.description
                    +"</div>\n";
            } else {
                string = string + "<div data-id='"+k+"' data-calc='"+vehicle+"' data-prop='packageVal' id='calc' " +
                    "style='width:" + Math.round((100 / (Object.keys(json['subscription'][vehicle]['subscription'][initPrice].time[selectedTime].limitKM[initLimitKm].package).length)) * 100) / 100 + "%'>" +
                    v.description
                    +"</div>\n";
            }

        });
    }
    return string;
}

function getSubscriptionPrice(vehicle, selectedPrice, selectedTime, selectedLimitKM, selectedPackage) {
    // var noteLimitKM = '20 000 km',
    //     noteInitialPrice = '0%';

    $('.show-package-package_1').css('display', 'list-item');
    $('.show-package-package_2').css('display', 'none');

    switch (selectedPackage) {
        case 0:
            $('.show-package-package_1').css('display', 'list-item');
            $('.carousel__button.button').removeClass('mobile-bottom');
            break;
        case 1:
            $('.show-package-package_2').css('display', 'list-item');
            $('.carousel__button.button').addClass('mobile-bottom');
            break;
    }

    if (json['subscription'][vehicle] && json['subscription'][vehicle]['subscription'] &&
      json['subscription'][vehicle]['subscription'][initPrice] &&
      json['subscription'][vehicle]['subscription'][initPrice].time[selectedTime] &&
      json['subscription'][vehicle]['subscription'][initPrice].time[selectedTime].limitKM[initLimitKm] &&
      json['subscription'][vehicle]['subscription'][initPrice].time[selectedTime].limitKM[initLimitKm].package[selectedPackage]
    ) {

        return json['subscription'][vehicle]['subscription'][initPrice].time[selectedTime].limitKM[initLimitKm].package[selectedPackage].netto;
        // if (json['subscription'][vehicle] !== undefined) {
        //     $('#note-price-package-1-' + vehicle).html(json['subscription'][vehicle]['subscription'][0].limitKM[selectedLimitKM].initialPrice[selectedInitialPrice].netto.format());
        //     if (json['subscription'][vehicle]['subscription'][1]) {
        //         $('#note-price-package-2-' + vehicle).html(json['subscription'][vehicle]['subscription'][1].limitKM[selectedLimitKM].initialPrice[selectedInitialPrice].netto.format());
        //     }
        // }

        // $('.note_limit_km').html(noteLimitKM);
        // $('.note_initial_price').html(noteInitialPrice);

        // if (json['subscription'][vehicle]['subscription'][selectedPackage]) {
        //     return json['subscription'][vehicle]['subscription'][selectedPackage].limitKM[selectedLimitKM].initialPrice[selectedInitialPrice].netto.format();
        // } else {
        //     return json['subscription'][vehicle]['subscription'][0].limitKM[selectedLimitKM].initialPrice[selectedInitialPrice].netto.format();
        // }
    }

    return null;
}

Number.prototype.format = function(){
    var t = ' ';
    var n = this,
        i = String(parseInt(n = Math.abs(Number(n) || 0))),
        j = (j = i.length) > 3 ? j % 3 : 0;
    return (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t);
};



function reloadSubscriptionCalculators(selector) {
    var selectorProp = selector.data('prop'),
        selectorId = selector.data('id');

    $('[data-calculator-init]').each(function (index, el) {
        var $el = $(el).find('[data-prop="' + selectorProp + '"][data-id="' + selectorId + '"]');
        if ($el.data('calc')) {
            reloadSubscriptionCalculator($el.data('calc'), $el);
        }
    });
}

function reloadSubscriptionCalculator(calc, selector) {
    // var initPrice = 0;
    // var initTime = 0;
    // var initLimitKm = 0;
    // var initPackageVal = 0;
    var calculator = selector.closest("[data-calculator-init]");

    if (selector.data('prop') === 'packageVal') {
        initTimeVal = getSubscriptionSelectedTime(calculator);
        initLimitKm = getSubscriptionSelectedLimit(calculator);
        initPackageVal = selector.data('id');
        initPrice = getSubscriptionSelectedPrice(calculator);
    } else if (selector.data('prop') === 'limitKm') {
        initTimeVal = getSubscriptionSelectedTime(calculator);
        initLimitKm = selector.data('id');
        initPackageVal = getSubscriptionSelectedPackage(calculator);
        initPrice = getSubscriptionSelectedPrice(calculator);
    } else if (selector.data('prop') === 'time') {
        initTimeVal = selector.data('id');
        initLimitKm = getSubscriptionSelectedLimit(calculator);
        initPackageVal = getSubscriptionSelectedPackage(calculator);
        initPrice = getSubscriptionSelectedPrice(calculator);
    } else if (selector.data('prop') === 'price') {
        initTimeVal = getSubscriptionSelectedTime(calculator);
        initLimitKm = getSubscriptionSelectedLimit(calculator);
        initPackageVal = getSubscriptionSelectedPackage(calculator);
        initPrice = selector.data('id');
    }

    var temp = template;
    var initialPrices = getInitialSubscriptionPrices(calc, initPrice);
    var time = getTime(calc, initPrice, initTimeVal);
    var limitKm = getSubscriptionLimitsKm(calc, initPrice, initTimeVal, initLimitKm);
    var packageVal = getSubscriptionPackage(calc, initPrice, initTimeVal, initLimitKm, initPackageVal);
    var price = getSubscriptionPrice(calc, initPrice, initTimeVal, initLimitKm, initPackageVal);


    // if (price === null) {
    //     initialPrices = getInitialSubscriptionPrices(calc);
    //     time = getInitialTime(calc, 0);
    //     limitKm = getSubscriptionLimitsKm(calc, 0, 0);
    //     price = getSubscriptionPrice(calc, 0, 0);
    //     packageVal = getSubscriptionPackage(calc, calculator);
    // }

    calculator.find("[data-time]").html(time);
    calculator.find("[data-initialPrices]").html(initialPrices);
    calculator.find("[data-limitKM]").html(limitKm);
    calculator.find("[data-packageVal]").html(packageVal);

    var comma_separator_number_step = $.animateNumber.numberStepFactories.separator(' ');
    calculator.find("[data-price]").animateNumber(
        {
            number: price,
            numberStep: comma_separator_number_step
        }
    );
}

function priceToInt(price) {
    return price.replace(' ', '');
}

function getSubscriptionSelectedPrice(calculator) {
    var el = calculator.find(".isActive[data-prop='price']");
    if (el[0]) {
        return $(el[0]).data('id');
    }
}

function getSubscriptionSelectedLimit(calculator) {
    var el = calculator.find(".isActive[data-prop='limitKm']");
    if (el[0]) {
        return $(el[0]).data('id');
    }
}

function getSubscriptionSelectedPackage(calculator) {
    var el = calculator.find(".isActive[data-prop='packageVal']");
    if (el[0]) {
        return $(el[0]).data('id');
    }
}
function getSubscriptionSelectedTime(calculator) {
    var el = calculator.find(".isActive[data-prop='time']");
    if (el[0]) {
        return $(el[0]).data('id');
    }
}

// LEASING

// Init dla kalkulatorów leasingu
function initLeasingCalculators() {
    let modelsToAttach = [];
    $('[data-calculator-leasing]').each(function (index, el) {
        let calculator_id = $(this).attr('data-version-id'),
            financing_key = $(this).attr('data-calculator-leasing'),
            model_code = $(this).attr('data-model-code'),
            model_name = $(this).attr('data-model-name'),
            version_name = $(this).attr('data-version-name');

        if (json['leasing'][financing_key] && json['leasing'][financing_key].leasing !== undefined && json['leasing'][financing_key].leasing.gross_price !== undefined) {
            if (!fcp.getOffers().hasOwnProperty(calculator_id)) {
                let baseNetPrice = Math.round(json['leasing'][financing_key].leasing.base_gross_price / 1.23),
                    netPrice =  Math.round(json['leasing'][financing_key].leasing.gross_price / 1.23);

                modelsToAttach.push({
                    id: calculator_id,
                    data: {
                        "modelName": model_name, // Nazwa modelu
                        "modelCode": model_code.split('-')[0], // Kod handlowy modelu
                        "versionName": version_name, // Nazwa wersji
                        "grossPrice": json['leasing'][financing_key].leasing.gross_price , // Cena po rabatach brutto + OT
                        "netPrice": netPrice, // Cena po rabatach netto + OT
                        "baseGrossPrice": json['leasing'][financing_key].leasing.base_gross_price, // Cena katalogowa brutto
                        "baseNetPrice": baseNetPrice, // Cena katalogowa netto
                        "fuelType": json['leasing'][financing_key].leasing.fuel_type, // Rodzaj paliwa (napędu) Benzyna | Olej napędowy | PHEV | MHEV | BEV
                        "versionId": json['leasing'][financing_key].leasing.sincom, // Sincom wersji (nie wymagany, jeśli podano kod LCDV)
                    },
                    initFields: null, // init fields
                });

                if (listBlockCalculator[calculator_id] === undefined) {
                    listBlockCalculator[calculator_id] = false;
                }
            }
        }
    });

    setTimeout(() => {
        modelsToAttach.forEach((item, key) => {
            fcp.attachOffer(item.id, item.data, item.initFields, [], true);
        });
    }, 100);
}

function setLeasingInstallmentTime(value, model = '') {
    if (model !== '') {
        model = '-' + model;
    } else {
        model = '';
    }
    switch (value) {
        case 24:
            $('[data-leasingTime' + model + ']').text('na 24 miesiące');
            // $('.note_leasing_ammount_total' + model).text('24 miesiące');
            // $('.note_leasing_ammount' + model).text('23');
            break;
        case 36:
            $('[data-leasingTime' + model + ']').text('na 36 miesięcy');
            // $('.note_leasing_ammount_total' + model).text('36 miesięcy');
            // $('.note_leasing_ammount' + model).text('35');
            break;
        case 48:
            $('[data-leasingTime' + model + ']').text('na 48 miesięcy');
            // $('.note_leasing_ammount_total' + model).text('48 miesięcy');
            // $('.note_leasing_ammount' + model).text('47');
            break;
        case 60:
            $('[data-leasingTime' + model + ']').text('na 60 miesięcy');
            // $('.note_leasing_ammount_total' + model).text('60 miesięcy');
            // $('.note_leasing_ammount' + model).text('59');
            break;
    }
}

function setInstallmentVisual(element, installment, modelCode) {
    let comma_separator_number_step = $.animateNumber.numberStepFactories.separator(' ', 3);
    installment = Math.ceil(installment);
    if ($(element + ' .installment').text() === '') {
        $(element + ' .carousel__headline-installment').html('' +
            '<h1 class="h1"><strong class="installment"></strong> zł\n' +
            '    <small class="h1__small">netto<br>miesięcznie<br><small class="smaller" data-leasingTime data-leasingTime-' + modelCode + '></small></small>\n' +
            '</h1>');
    }
    $(element + ' .installment').animateNumber(
        {
            number: installment,
            numberStep: comma_separator_number_step
        },
        250
    );
}

function setInstallmentModel(element, installment) {
    let comma_separator_number_step = $.animateNumber.numberStepFactories.separator(' ', 3);
    installment = Math.ceil(installment);
    if ($(element + ' .installment').text() === '') {
        $(element + ' .model__headline-installment').html('' +
            '<h2 class="calculator__headline__h2">Rata miesięczna</h2>' +
            '<h1 class="calculator__headline__h1"><strong class="installment">1 999</strong> zł\n' +
            '    <small class="calculator__headline__h1__small">netto</small>\n' +
            '</h1>');
    }
    $(element + ' .installment').animateNumber(
        {
            number: installment,
            numberStep: comma_separator_number_step
        },
        250
    );
}

function createSlider(position, modelName, versionId, sliderName, currentFields, availableFields, financialProduct, firstSlider, countFields) {
    let currentValue = 0,
        minLabel = '',
        maxLabel = '',
        value,
        sliderLabel = '',
        contributionPrice = '',
        sliderButtons = '',
        hideSliderText = '',
        noSlide = '';

    const min = 0,
        max = availableFields.length - 1,
        step = 1,
        availableFieldsLength = availableFields.length;

    if (sliderName === 'contribution') {
        sliderLabel = 'WPŁATA WŁASNA';
    } else if (sliderName === 'period') {
        sliderLabel = 'OKRES LEASINGU';
    } else if (sliderName === 'repurchase') {
        sliderLabel = 'WARTOŚĆ WYKUPU';
    } else {
        sliderLabel = currentFields.description;
    }

    if (sliderName === 'contribution') {
        contributionPrice = '<br /><span class="small-price">' + currentFields.description.replace('Wkład własny ', '') + '</span>\n';
    } else if (sliderName === 'period') {
        setLeasingInstallmentTime(currentFields.value, modelName);
    }

    if (availableFieldsLength > 1 && availableFieldsLength < 5) {
        let items = '';
        for (let item in availableFields) {
            items += '<li class="label_list__item">' + availableFields[item].label + '</li>\n';
        }
        sliderButtons = '' +
            '<ul class="label_list label_list--' + availableFieldsLength + ' list-unstyled">\n' +
                items +
            '</ul>';
        hideSliderText = ' hide-ui-slider-handle-text';
    } else if (availableFieldsLength === 1) {
        noSlide = ' ui-slider-handle-no-slide';
    }

    let sliderHTML = '' +
        '<div class="calculator__parameter calculator__parameter--' + sliderName + '">\n' +
        '    <div class="calculator__label">\n' +
        '        ' + sliderLabel + '\n' + contributionPrice +
        '    </div>\n' +
        '    <div class="calculator__data' + hideSliderText + noSlide +'">\n' +
        '        <div class="calculator__slider" data-' + sliderName + '></div>\n' + sliderButtons +
        '    </div>\n' +
        '</div>';

    let calculatorPath = '.calculator-' + position + '-' + modelName + '[data-version-id="' + versionId + '"] .calculator-sliders';

    if (firstSlider) {
        $(calculatorPath).html(sliderHTML);
    } else {
        $(calculatorPath).append(sliderHTML);
    }

    let $slider = $(calculatorPath + ' .calculator__slider[data-' + sliderName + ']');

    if ($slider.slider('instance') !== undefined) {
        $slider.slider('destroy');
    }

    value = min;
    currentValue = currentFields.value;

    availableFields.forEach((element, key) => {
        if (currentValue === element.value) {
            value = key;
        }

        if(key === 0) {
            if (sliderName === 'period') { // dla okresu label bez "m-cy"
                minLabel = element.value;
            } else {
                minLabel = element.label;
            }
        } else if(key === availableFields.length - 1) {
            if (sliderName === 'period') { // dla okresu label bez "m-cy"
                maxLabel = element.value;
            } else {
                maxLabel = element.label;
            }
        }
    });

    $slider.slider({
        value: value,
        min: min,
        max: max,
        step: step,
        create: function (event, ui) {
            $slider.find('.ui-slider-handle').html('<span class="ui-slider-handle-text">' + availableFields[value].label + '<span>');

            if(calculator[position][versionId] === undefined) {
                calculator[position][versionId] = {};
            }

            if(calculator[position][versionId]['fields'] === undefined) {
                calculator[position][versionId]['fields'] = {};
            }

            calculator[position][versionId]['fields'][sliderName] = availableFields[value].value;
            calculator[position][versionId]['currentFinancialCalculator'] = financialProduct;
            calculator[position][versionId]['currentVersionId'] = versionId;
            calculator[position][versionId]['modelName'] = modelName;
        },
        stop: function (event, ui) {
            $slider.slider("option", "value", ui.value);

            if (calculator[position][versionId]['fields'][sliderName] !== availableFields[ui.value].value) {
                calculator[position][versionId]['fields'][sliderName] = availableFields[ui.value].value;
                updateLeasingCalculation(position, modelName, versionId);
            }
        },
        slide: function (event, ui) {
            $slider.find('.ui-slider-handle').html('<span class="ui-slider-handle-text">' + availableFields[ui.value].label + '<span>');
        },
    });
}

function updateLeasingCalculation(position, modelCode, versionId, fields = true) {
    listBlockCalculator[versionId] = true;
    if (fields) {
        fcp.updateOfferCalculationById(versionId, clientTypeLeasing, calculator[position][versionId].fields);

        if (position === 'model') {
            Object.keys(calculator.model).forEach(function(k) {
                if (modelCode === calculator.model[k].modelName && versionId !== calculator.model[k].currentVersionId &&
                    calculator.model[versionId].currentFinancialCalculator === calculator.model[k].currentFinancialCalculator) {
                    if (JSON.stringify(calculator.model[k].fields) !== JSON.stringify(calculator.model[versionId].fields)) {
                        calculator.model[k].fields = JSON.parse(JSON.stringify(calculator.model[versionId].fields));
                        updateLeasingCalculation('model', modelCode, calculator.model[k].currentVersionId);
                    }
                }
            });
        }
    } else {
        fcp.updateOfferCalculationById(versionId, clientTypeLeasing, null);
    }

    setTimeout(()=> {
        if(listBlockCalculator[versionId]) {
            let $calc = $('.calculator-' + position + '-' + modelCode + '[data-version-id="' + versionId + '"]');
            if (position === 'visual') {
                $calc.find('.carousel__headline-installment').addClass('blur');
                $calc.find('.calculator-sliders').css('visibility', 'hidden');
                $calc.find('.visual-calculator-error').removeClass('inline-block');
                $calc.find('.visual-calculator-loader').addClass('inline-block');
            } else {
                $calc.find('.model__headline-installment').addClass('blur');
                $calc.find('.calculator-sliders').css('visibility', 'hidden');
                $calc.find('.model-calculator-error').removeClass('inline-block');
                $calc.find('.model-calculator-loader').addClass('inline-block');
                $calc.find('.model-surcharge-info').css('visibility', 'hidden');
            }
        }
    }, 500);
}

function setCalculationParams(element, calculation, sincom) {
    if (calculation.calculationParams) {
        let html = '' +
            '<div class="calculation"><p>Parametry przyjęte do kalkulacji:</p><p class="calculation-data">' +
            '<strong>' + calculation.title + '</strong>'
            + '<br />Cena katalogowa netto: '+
            ((calculation.calculationParams.baseNetPrice !== null && calculation.calculationParams.baseNetPrice !== undefined) ? calculation.calculationParams.baseNetPrice + ' zł' : '-----')
            + '<br />Cena katalogowa brutto: '+
            ((calculation.calculationParams.baseGrossPrice !== null && calculation.calculationParams.baseGrossPrice !== undefined) ? calculation.calculationParams.baseGrossPrice + ' zł' : '-----')
            + '<br />Cena po rabatach netto: ' +
            ((calculation.calculationParams.netPrice !== null && calculation.calculationParams.netPrice !== undefined) ? calculation.calculationParams.netPrice + ' zł' : '-----')
            + '<br />Cena po rabatach brutto: ' +
            ((calculation.calculationParams.grossPrice !== null && calculation.calculationParams.grossPrice !== undefined) ? calculation.calculationParams.grossPrice + ' zł' : '-----')
            + '<br />Oprocentowanie: ' +
            ((calculation.calculationParams.rate !== null && calculation.calculationParams.rate !== undefined) ? calculation.calculationParams.rate + '%' : '-----')
            + '<br />Subwencja: ' +
            ((calculation.calculationParams.subsidy !== null && calculation.calculationParams.subsidy !== undefined) ? calculation.calculationParams.subsidy + '%' : '-----')
            + '<br />RV: ' +
            ((calculation.calculationParams.rv !== null && calculation.calculationParams.rv !== undefined) ? calculation.calculationParams.rv + '%' : '-----')
            + '<br />Opłata przygotowawcza: ' +
            ((calculation.calculationParams.preparationFee !== null && calculation.calculationParams.preparationFee !== undefined) ? calculation.calculationParams.preparationFee + '%' : '-----')
            + '<br />Opłata miesięczna: ' +
            ((calculation.calculationParams.monthlyManagementFee !== null && calculation.calculationParams.monthlyManagementFee !== undefined) ? calculation.calculationParams.monthlyManagementFee + ' zł' :'-----')
            + '<br />Kwota finansowana netto: ' +
            ((calculation.calculationParams.netCreditAmount !== null && calculation.calculationParams.netCreditAmount !== undefined) ? calculation.calculationParams.netCreditAmount + ' zł' :'-----')
            + '<br />Kwota finansowana brutto: ' +
            ((calculation.calculationParams.grossCreditAmount !== null && calculation.calculationParams.grossCreditAmount !== undefined) ? calculation.calculationParams.grossCreditAmount + ' zł' :'-----')
            + ((calculation.currentFields.contribution.description !== null && calculation.currentFields.contribution.description !== undefined) ? '<br />' + calculation.currentFields.contribution.description.replace('Wkład własny', 'Wkład własny:') : '')
            + '<br />Produkt SOL: ' + ((calculation.psaProduct !== null && calculation.psaProduct !== undefined) ? calculation.psaProduct : '-----')
            + '<br />Subprodukt SOL: ' + ((calculation.psaSubProduct !== null && calculation.psaSubProduct !== undefined) ? calculation.psaSubProduct : '-----')
            + '<br />Kod wersji: ' + sincom
            + '<br />Kod LCDV: ' + ((calculation.vehicleLCDV !== null && calculation.vehicleLCDV !== undefined) ? calculation.vehicleLCDV : '-----')
            + '</p></div>';
        $('.calculation-' + element).html(html);
    }
}

$(document).ready(function () {
    if (app_js.mode !== 'development') {
        Sentry.init({
            dsn: 'https://bdd8b4ccfd8c40c391d2d6090ac49bc0@sentry.unicorn.net.pl/44',
            environment: app_js.mode,
            ignoreErrors: [
                // Random plugins/extensions
                "top.GLOBALS",
                // SPAM ERRORS!
                "SecurityError: Blocked a frame with origin \"https://finansowanie.fiatprofessional.pl\" from accessing a cross-origin frame.",
                "TypeError: Failed to fetch",
                /Non-Error promise rejection captured with value: EU compliance was not acknowledged by the user/,
                /Error: Navigation cancelled from/,
                /DY is not defined/
            ],
            denyUrls: [
                // Facebook
                /graph\.facebook\.com/i,
                /connect\.facebook\.net\/en_US\/all\.js/i,
                // Chrome extensions
                /extensions\//i,
                /^chrome:\/\//i,
            ],
        });
    }
});
